<template>
  <div id="app" v-if="show">
    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta || !$route.meta.keepAlive" />
  </div>
</template>
<script>
import { fetchGetTmpUuid, fetchPixelReport } from '@/api'
import { USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY } from './utils/constant'
import Cookies from 'js-cookie'
import { setCookieFbc, setCookieAdId, getPathLang, getAppInfo, getFbPixelId } from './utils/base'
import { initGa4 } from './utils/ga4'



export default {
  name: 'App',
  data() {
    return {
      show: true
      // Define any global data properties here
    }
  },
  
  methods: {
 
    async getUuid(){
      try {
        if(Cookies.get(USER_ID_COOKIES_KEY)){
          return
        }
        const uuid = fetchGetTmpUuid()
        Cookies.set(USER_ID_COOKIES_KEY, uuid)
      }catch (error) {
        console.error('Error fetching UUID:', error)
      }
    },
    reportFb(){  
      console.log('reportFb')
    }
  },
  mounted() {
    initGa4()
    console.log(getFbPixelId(), 'pixelid')
    window.fbq('init', getFbPixelId()); 
    document.title = getAppInfo()?.name;
    console.log(getAppInfo(), 'app 基本配置')
    this.$i18n.locale = getPathLang()
    setCookieAdId();
    setCookieFbc();
    this.getUuid()

  }
}
</script>


<style lang="less">

</style>
